import { atom } from "recoil";
import { FilterDef } from "../../../constants/FinanceModels";

export const STATE_CLUSTERS_TABLE_UPDATING = atom<boolean>({
    key: "cluster-state-table-updating",
    default: false
});

export const STATE_STORES_TABLE_UPDATING = atom<boolean>({
    key: "cluster-state-stores-table-updating",
    default: false
});

export const STATE_VOICES_TABLE_UPDATING = atom<boolean>({
    key: "cluster-state-voices-table-updating",
    default: false
});

export const STATE_FIXED_VOICE_TABLE_UPDATING = atom<boolean>({
    key: "cluster-state-fixed-voices-table-updating",
    default: false
});

// The state of active filters on Cluster's reports page
export const STATE_CLUSTERS_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'cluster-state-active-filters',
    default: []
});

export const STATE_STORES_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'cluster-state-stores-active-filters',
    default: []
});

export const STATE_VOICES_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'cluster-state-voices-active-filters',
    default: []
});

export const STATE_FIXED_VOICE_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'cluster-state-fixed-voices-active-filters',
    default: []
});

export const STATE_CLUSTERS_TOTAL_COUNT = atom<any>({
    key: 'cluster-state-total-count',
    default: null
});
export const STATE_STORES_TOTAL_COUNT = atom<any>({
    key: 'cluster-state-stores-total-count',
    default: null
});
export const STATE_VOICES_TOTAL_COUNT = atom<any>({
    key: 'cluster-state-voices-total-count',
    default: null
});